export default "__VITE_ASSET__CV4_F76$__"